<template>
  <div
    :id="id"
    class="flex cursor-pointer items-center gap-1.5 px-4 py-2 hover:bg-surface-muted"
    :class="rootClasses"
    @click="onClick">
    <div
      v-if="$slots.icon"
      class="mt-0.5">
      <slot name="icon" />
    </div>
    <span class="truncate">{{ title }}</span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MenuOption',
  emits: ['select'],
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rootClasses() {
      const rootClasses: string[] = []

      if (this.isDisabled) {
        rootClasses.push('pointer-events-none opacity-50')
      }

      return rootClasses
    },
  },
  methods: {
    onClick() {
      if (this.isDisabled) {
        return
      }

      this.$emit('select', this.id)
    },
  },
}
</script>

